const map = {
	"./about-g1.jpg": 2446,
	"./about-g2.jpg": 2041,
	"./about-g3.jpg": 428,
	"./about-g4.jpg": 6743,
	"./arrow_left.svg": 8148,
	"./arrow_right.svg": 4427,
	"./bilibili.svg": 9973,
	"./book-shadow-left.png": 2992,
	"./book-shadow-right.png": 8853,
	"./building.jpg": 938,
	"./china_map.jpg": 2482,
	"./consluting.jpg": 3252,
	"./contact.jpg": 464,
	"./contact.webp": 4169,
	"./culture_1.png": 6382,
	"./culture_2.png": 3733,
	"./culture_3.png": 4636,
	"./culture_4.png": 4803,
	"./culture_5.png": 7226,
	"./default_avatar.jpg": 7643,
	"./grid-1-1.jpg": 8118,
	"./grid-1-1.webp": 579,
	"./grid-1-2.jpg": 7697,
	"./grid-1-2.webp": 258,
	"./grid-1-3.jpg": 9652,
	"./grid-1-3.webp": 5197,
	"./grid-2-1.jpg": 9929,
	"./grid-2-1.webp": 1466,
	"./grid-2-3.jpg": 3899,
	"./grid-2-3.webp": 8168,
	"./grid-2-4.jpg": 7416,
	"./grid-2-4.webp": 3713,
	"./interior.jpg": 5374,
	"./interior.webp": 6395,
	"./landscape.jpg": 4875,
	"./logo.svg": 1792,
	"./map-mobile.jpg": 6871,
	"./no-data.png": 6950,
	"./people-banner-1.jpg": 3154,
	"./people-banner-2.jpg": 3053,
	"./planning.jpg": 9397,
	"./residential-1.jpg": 3748,
	"./residential-2.jpg": 9971,
	"./residential-3.jpg": 5206,
	"./shipinhao-qr.jpg": 5649,
	"./shipinhao.svg": 9150,
	"./sustainable.jpg": 2827,
	"./tianhua2019-bill.png": 3910,
	"./tianhua2020-banner.png": 1775,
	"./tianhua2020-bill.png": 1337,
	"./tianhua2020-notify.png": 474,
	"./vetting.jpg": 2509,
	"./vrtech-1.jpg": 2880,
	"./vrtech-2.jpg": 6607,
	"./vrtech-3.jpg": 4898,
	"./vrtech-4.jpg": 129,
	"./vrtech-5.jpg": 1972,
	"./vrtech-6.jpg": 416,
	"./wechat-qr.jpg": 8438,
	"./wechat.svg": 1555,
	"./weibo.svg": 8607,
	"./xiaohongshu-qr.jpg": 5619,
	"./xiaohongshu.svg": 9804,
	"./zhihu.svg": 5185,
	"images/about-g1.jpg": 2446,
	"images/about-g2.jpg": 2041,
	"images/about-g3.jpg": 428,
	"images/about-g4.jpg": 6743,
	"images/arrow_left.svg": 8148,
	"images/arrow_right.svg": 4427,
	"images/bilibili.svg": 9973,
	"images/book-shadow-left.png": 2992,
	"images/book-shadow-right.png": 8853,
	"images/building.jpg": 938,
	"images/china_map.jpg": 2482,
	"images/consluting.jpg": 3252,
	"images/contact.jpg": 464,
	"images/contact.webp": 4169,
	"images/culture_1.png": 6382,
	"images/culture_2.png": 3733,
	"images/culture_3.png": 4636,
	"images/culture_4.png": 4803,
	"images/culture_5.png": 7226,
	"images/default_avatar.jpg": 7643,
	"images/grid-1-1.jpg": 8118,
	"images/grid-1-1.webp": 579,
	"images/grid-1-2.jpg": 7697,
	"images/grid-1-2.webp": 258,
	"images/grid-1-3.jpg": 9652,
	"images/grid-1-3.webp": 5197,
	"images/grid-2-1.jpg": 9929,
	"images/grid-2-1.webp": 1466,
	"images/grid-2-3.jpg": 3899,
	"images/grid-2-3.webp": 8168,
	"images/grid-2-4.jpg": 7416,
	"images/grid-2-4.webp": 3713,
	"images/interior.jpg": 5374,
	"images/interior.webp": 6395,
	"images/landscape.jpg": 4875,
	"images/logo.svg": 1792,
	"images/map-mobile.jpg": 6871,
	"images/no-data.png": 6950,
	"images/people-banner-1.jpg": 3154,
	"images/people-banner-2.jpg": 3053,
	"images/planning.jpg": 9397,
	"images/residential-1.jpg": 3748,
	"images/residential-2.jpg": 9971,
	"images/residential-3.jpg": 5206,
	"images/shipinhao-qr.jpg": 5649,
	"images/shipinhao.svg": 9150,
	"images/sustainable.jpg": 2827,
	"images/tianhua2019-bill.png": 3910,
	"images/tianhua2020-banner.png": 1775,
	"images/tianhua2020-bill.png": 1337,
	"images/tianhua2020-notify.png": 474,
	"images/vetting.jpg": 2509,
	"images/vrtech-1.jpg": 2880,
	"images/vrtech-2.jpg": 6607,
	"images/vrtech-3.jpg": 4898,
	"images/vrtech-4.jpg": 129,
	"images/vrtech-5.jpg": 1972,
	"images/vrtech-6.jpg": 416,
	"images/wechat-qr.jpg": 8438,
	"images/wechat.svg": 1555,
	"images/weibo.svg": 8607,
	"images/xiaohongshu-qr.jpg": 5619,
	"images/xiaohongshu.svg": 9804,
	"images/zhihu.svg": 5185
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1729;